import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
} from '@material-ui/core';
import {
  editEventTemplate,
  deleteEventTemplate,
} from '@pingum/app-state-management/eventTemplate/actions';

export class ArchiveDeleteEventTemplateModalComponent extends React.Component {
  handleDeleteConfirm = () => {
    this.props.eventTemplateIds.forEach((eventTemplateId) => this.props.deleteEventTemplate(eventTemplateId));
    this.props.handleCloseModal();
  }

  handleArchiveConfirm = () => {
    this.props.eventTemplateIds.forEach((eventTemplateId) => this.props.editEventTemplate(eventTemplateId, { archived: true }));
    this.props.handleCloseModal();
  }

  render() {
    const { eventTemplateIds } = this.props;
    return (
      <div>
        <Dialog
          open={this.props.isOpen}
          onClose={this.props.handleCloseModal}
          aria-labelledby="edit-user-title"
          aria-describedby="edit-user-description"
        >
          <DialogTitle>
            {
              eventTemplateIds.length > 1
                ? 'Archive or Delete Workflows'
                : 'Archive or Delete Workflow'
            }
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              <strong>Are you sure you want to perform this action?</strong>
            </DialogContentText>
            <DialogContentText>
              You will perform this action on {eventTemplateIds.length}
              {
                eventTemplateIds.length > 1
                  ? ' workflows'
                  : ' workflow'
              }
            </DialogContentText>
            <DialogContentText>
              <strong>Archiving</strong> will remove an event workflow
              from dashboards and other forms from which users
              create events. The event workflow can later be restored and used again.
            </DialogContentText>
            <DialogContentText>
              <strong>Deleting</strong> will permanently remove the event workflow.
              This action cannot be undone.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.props.handleCloseModal}>
              Cancel
            </Button>
            <Button
              onClick={() => { this.handleDeleteConfirm(); }}
              color="secondary"
              autoFocus
            >
              Delete
            </Button>
            <Button
              onClick={() => { this.handleArchiveConfirm(); }}
              color="primary"
              autoFocus
            >
              Archive
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

ArchiveDeleteEventTemplateModalComponent.propTypes = {
  eventTemplateIds: PropTypes.arrayOf(PropTypes.number),
  isOpen: PropTypes.bool,
  handleCloseModal: PropTypes.func,
  editEventTemplate: PropTypes.func,
  deleteEventTemplate: PropTypes.func,
};

ArchiveDeleteEventTemplateModalComponent.defaultProps = {
  eventTemplateIds: [],
  isOpen: false,
  handleCloseModal: () => { },
  editEventTemplate: () => {},
  deleteEventTemplate: () => {},
};

export const mapDispatchToProps = (dispatch) => ({
  editEventTemplate: (eventTemplateId, request) => dispatch(editEventTemplate(eventTemplateId, request)),
  deleteEventTemplate: (eventTemplateId) => dispatch(deleteEventTemplate(eventTemplateId)),
});

export default connect(
  null,
  mapDispatchToProps,
)(ArchiveDeleteEventTemplateModalComponent);
